import findIntersections from 'helpers/walls/findIntersections'

/**
 * Computes the polygon path in the case where exactly one wall endpoint is in the FoV
 *
 * @param {Object} args - Object to be deconstructed which contains arguments
 * @param {google.maps.Point} args.innerPoint - The inner wall endpoint
 * @param {google.maps.Point} args.proj - The projection of the inner point to the edge of the camera FoV
 * @param {google.maps.Point} args.outerPoint - The outer wall endpoint
 * @param {google.maps.Point} args.cameraPoint - Point corresponding to the camera marker
 * @param {google.maps.Point} args.leftPoint - Point corresponding to the left angle marker
 * @param {google.maps.Point} args.rightPoint - Point corresponding to the right angle marker
 * @return {Array} The path of the polygon
 */

export default function buildPolygon({ innerPoint, proj, outerPoint, cameraPoint, leftPoint, rightPoint }) {
  const { left, right, end } = findIntersections({ innerPoint, outerPoint, cameraPoint, leftPoint, rightPoint })

  if (left) {
    return [innerPoint, proj, leftPoint, left, innerPoint]
  } else if (right) {
    return [innerPoint, right, rightPoint, proj, innerPoint]
  } else {
    return [innerPoint, proj, end, innerPoint]
  }
}



// WEBPACK FOOTER //
// ./src/helpers/walls/buildPolygon.js